import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { IntegracionToken, IntegracionTokenCreateResponse } from "../models/Integraciones/IntegracionToken";
import { Response } from "../shared/models/Response";

@Injectable({
  providedIn: "root",
})
export class IntegracionesService {
  private REST_API_SERVER = environment.backend_server + "/Integraciones";

  constructor(private http: HttpClient) {}

  getTokens(emisorId: string): Observable<Response<IntegracionToken[]>> {
    return this.http.get<Response<IntegracionToken[]>>(`${this.REST_API_SERVER}/tokens/${emisorId}`);
  }

  createToken(payload: { emisorId: string; nombre: string }): Observable<Response<IntegracionTokenCreateResponse>> {
    return this.http.post<Response<IntegracionTokenCreateResponse>>(`${this.REST_API_SERVER}/tokens`, payload);
  }

  rotateToken(tokenId: string): Observable<Response<IntegracionTokenCreateResponse>> {
    return this.http.post<Response<IntegracionTokenCreateResponse>>(`${this.REST_API_SERVER}/tokens/${tokenId}/rotate`, {});
  }

  revokeToken(tokenId: string): Observable<Response<boolean>> {
    return this.http.post<Response<boolean>>(`${this.REST_API_SERVER}/tokens/${tokenId}/revoke`, {});
  }
}
